var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useRef, useEffect, } from 'react';
import { makeStyles, createStyles, Button, withStyles, FormControl, FormHelperText, } from '@material-ui/core';
import { PlainText } from 'component/LHH/MasterGrids/MasterGrids';
import StyledA from 'component/utility/StyledA';
import { generateRandomString } from '../Table/consts';
// style----------------------------------------------------
export var StyleFormControl = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            padding: '5px',
        },
    });
})(FormControl);
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            padding: '6px 16px',
            fontSize: '0.875rem',
            minWidth: '64px',
            boxSizing: 'border-box',
            transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            fontFamily: "'Roboto', NotoSansTC",
            fontWeight: 500,
            lineHeight: 1.75,
            borderRadius: '4px',
            letterSpacing: '0.02857em',
            textTransform: 'uppercase',
            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
            },
        },
    });
});
export var StyledSpanButton = function (props) {
    var classes = useStyles();
    var text = props.text, other = __rest(props, ["text"]);
    return (React.createElement("span", __assign({ className: classes.root }, other),
        text,
        ' '));
};
export var StyleFormHelperText = withStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            margin: '5px 14px 0',
        },
    });
})(FormHelperText);
export var FileUpload = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _file = props._file, _d = props.accept, accept = _d === void 0 ? '.xls,.xlsx' : _d, other = __rest(props, ["inputRef", "verifyBeforeChange", "error", "helperText", "verifiers", "_file", "accept"]);
    var file = _file[0], setFile = _file[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState(verifyBeforeChange), FirstVerify = _f[0], setFirstVerify = _f[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!FirstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            for (var _i = 0, verifiers_1 = verifiers; _i < verifiers_1.length; _i++) {
                var obj = verifiers_1[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [file, verifyBeforeChange]);
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("label", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(StyledSpanButton, { text: "\u6A94\u6848\u4E0A\u50B3" }),
            React.createElement("input", __assign({ type: "file", accept: accept, ref: inputRef, hidden: true, onChange: function (e) { return setFile(e.target.files[0]); } }, other)),
            React.createElement(PlainText, null, !file ? '請選擇檔案...' : file.name)),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export var MultipleFileUpload = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _uploadFiles = props._uploadFiles, _downloadFiles = props._downloadFiles, _d = props.accept, accept = _d === void 0 ? '.xls,.xlsx' : _d, _e = props.maxSize, maxSize = _e === void 0 ? 10 : _e, _delFiles = props._delFiles, _delUploadedFiles = props._delUploadedFiles, other = __rest(props, ["inputRef", "verifyBeforeChange", "error", "helperText", "verifiers", "_uploadFiles", "_downloadFiles", "accept", "maxSize", "_delFiles", "_delUploadedFiles"]);
    var uploadFiles = _uploadFiles[0], setUploadFiles = _uploadFiles[1];
    var downloadFiles = _downloadFiles[0], getDownloadFile = _downloadFiles[1];
    var delFiles = _delFiles;
    var setDelUploadFiles = _delUploadedFiles;
    var _f = useState(''), message = _f[0], setMessage = _f[1];
    var _g = useState(verifyBeforeChange), firstVerify = _g[0], setFirstVerify = _g[1];
    var _h = useState(false), overSize = _h[0], setOverSize = _h[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            for (var _i = 0, verifiers_2 = verifiers; _i < verifiers_2.length; _i++) {
                var obj = verifiers_2[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    }, [uploadFiles, verifyBeforeChange]);
    var toBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { return resolve(reader.result); };
            reader.onerror = function (error) { return reject(error); };
        });
    };
    var updateFile = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var nowFiles, base64List, i, base64;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nowFiles = Array.from(e.target.files);
                    if (!(((nowFiles === null || nowFiles === void 0 ? void 0 : nowFiles.length) || 0) +
                        ((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) +
                        ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                        maxSize)) return [3 /*break*/, 1];
                    setOverSize(true);
                    return [3 /*break*/, 6];
                case 1:
                    setOverSize(false);
                    base64List = [];
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < nowFiles.length)) return [3 /*break*/, 5];
                    return [4 /*yield*/, toBase64(nowFiles[i])];
                case 3:
                    base64 = (_a.sent());
                    base64List.push({
                        transactionId: generateRandomString(),
                        content: base64 === null || base64 === void 0 ? void 0 : base64.split(',')[1],
                        fileName: nowFiles[i].name,
                    });
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5:
                    setUploadFiles(uploadFiles ? uploadFiles.concat(base64List) : base64List);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
            } },
            React.createElement("label", null,
                React.createElement(StyledSpanButton, { text: "\u6A94\u6848\u4E0A\u50B3" }),
                React.createElement("input", __assign({ type: "file", accept: accept, ref: inputRef, hidden: true, multiple: true, onChange: updateFile }, other))),
            overSize ? React.createElement(PlainText, null, "\u9078\u53D6\u8D85\u904E\u6700\u5927\u6A94\u6848\u6578\u91CF") : React.createElement(React.Fragment, null), downloadFiles === null || downloadFiles === void 0 ? void 0 :
            downloadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    marginTop: '20px',
                } },
                React.createElement("label", { style: { width: '100px' } },
                    React.createElement(StyledSpanButton, { style: { width: '100%', backgroundColor: 'red' }, text: "\u79FB\u9664\u6A94\u6848" }),
                    React.createElement("input", { accept: accept, ref: inputRef, hidden: true, onClick: function () {
                            setDelUploadFiles(downloadFiles.filter(function (nFile) { return file.transactionId !== nFile.transactionId; }), delFiles
                                ? delFiles.concat(file.transactionId)
                                : [file.transactionId]);
                            setOverSize(((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) + ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                                maxSize);
                        } })),
                React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                    React.createElement(StyledA, { onClick: getDownloadFile(file.fileName) }, file.fileName)))); }), uploadFiles === null || uploadFiles === void 0 ? void 0 :
            uploadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    marginTop: '20px',
                } },
                React.createElement("label", { style: { width: '100px' } },
                    React.createElement(StyledSpanButton, { style: { width: '100%', backgroundColor: 'red' }, text: "\u79FB\u9664\u6A94\u6848" }),
                    React.createElement("input", { accept: accept, ref: inputRef, hidden: true, onClick: function () {
                            setUploadFiles(uploadFiles.filter(function (nFile) { return file.transactionId !== nFile.transactionId; }));
                            setOverSize(((uploadFiles === null || uploadFiles === void 0 ? void 0 : uploadFiles.length) || 0) + ((downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.length) || 0) >
                                maxSize);
                        } })),
                React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                    React.createElement(PlainText, null, file.fileName)))); })),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
export var MultipleFile = function (props) {
    var _a = props.inputRef, inputRef = _a === void 0 ? useRef() : _a, _b = props.verifyBeforeChange, verifyBeforeChange = _b === void 0 ? false : _b, error = props.error, helperText = props.helperText, _c = props.verifiers, verifiers = _c === void 0 ? [] : _c, _downloadFiles = props._downloadFiles;
    var downloadFiles = _downloadFiles[0], getDownloadFile = _downloadFiles[1];
    var _d = useState(''), message = _d[0], setMessage = _d[1];
    var _e = useState(verifyBeforeChange), firstVerify = _e[0], setFirstVerify = _e[1];
    useEffect(function () {
        // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
        if (!firstVerify) {
            setFirstVerify(true);
            setMessage('');
            return;
        }
        // 驗 HTML validation
        if (inputRef.current && inputRef.current.validationMessage.length > 0) {
            setMessage(inputRef.current.validationMessage);
            return;
        }
        // 驗使用者設定之 verifier, 不驗空值(給 HTML required 驗)
        if (props.value && verifiers.length > 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, verifiers_3 = verifiers; _i < verifiers_3.length; _i++) {
                var obj = verifiers_3[_i];
                if (obj.func(props.value)) {
                    setMessage(obj.text);
                    return;
                }
            }
        }
        // 先前檢驗都 pass
        setMessage('');
    });
    return (React.createElement(StyleFormControl, { error: error || message.length > 0 },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
            } }, downloadFiles === null || downloadFiles === void 0 ? void 0 : downloadFiles.map(function (file, key) { return (React.createElement("div", { key: key, style: {
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                marginTop: '20px',
            } },
            React.createElement("label", { style: { width: 'calc(100% - 100px)' } },
                React.createElement(StyledA, { onClick: getDownloadFile(file.fileName) }, file.fileName)))); })),
        React.createElement(StyleFormHelperText, null, helperText || message)));
};
var Style_Button = withStyles({
    root: {
        borderRadius: '20px',
    },
})(Button);
export var ButtonContain = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (
    // eslint-disable-next-line react/jsx-pascal-case
    React.createElement(Style_Button, __assign({ variant: "contained", color: "primary" }, other), children));
};
export var ButtonContainO = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (React.createElement(Button, __assign({ variant: "contained", color: "primary" }, other), children));
};
export var ButtonOutline = function (props) {
    var children = props.children, other = __rest(props, ["children"]);
    return (React.createElement(Button, __assign({ variant: "outlined", color: "primary" }, other), children));
};
